import API from '@/services/api.js'
import Auth from '@/services/auth.js'
import merge from 'lodash/merge'

const actions = {
  //- Sets current user handled cases
  setHandledCases({ commit }, bool) {
    commit('SET_HANDLED_CASES', bool)
    if (bool)
      localStorage.setItem('my-errands-view', bool)
    else 
      localStorage.removeItem('my-errands-view')
  },

  //- Sets the current user on login
  async setCurrentUser({commit, getters,dispatch}, user) {
    console.log('Userstore - setCurrentUser')

    //- Set user data (set/clear auth header and localstore)
    if (user) {
      API.setHeaders('Authorization', `Bearer ${user.token}`)
      localStorage.setItem('user', JSON.stringify(user))
      await dispatch('basic/loadBasics', {}, {root: true})
    } else {
      API.setHeaders('Authorization', null)
      localStorage.removeItem('user')
      localStorage.removeItem('initiator_id')
    }

    //- Mutate store
    commit('SET_CURRENT_USER', user)

    //- Add casbin group to user
    if (user) {
      const role = getters.currentUserRole
      const id = getters.currentUserId

      //- Set role in Auth
      await Auth.addRoleForUser(String(id), role).then(() => {
        console.log('User ' + id + ' belongs to role ' + role)
      })

      //- Grab permissions user now has
      await Auth.getImplicitPermissionsForUser(String(id)).then(permissions => {
        commit(
          'SET_PERMISSIONS',
          Object.assign(
            {},
            merge(
              ...Array.from(permissions, ([r, k, v]) => ({[k]: {[v]: true}}))
            )
          )
        )
      })
    }
  },

  loadCurrentUser({dispatch}) {
    //- Try to grab user from localstorage and verify that data is correct
    console.log('Store - loadCurrentUser')

    // Grab user data from local storage
    const userString = localStorage.getItem('user')

    // check to see if there is indeed a user
    if (!userString) {
      //- No userstring in localstore
      return dispatch('setCurrentUser', null)
    }

    // parse user data into JSON and set API Auth headers
    let userData = null
    try {
      userData = JSON.parse(userString)
    } catch (e) {
      //- Somthing bad happende to localstore data
      console.log('Store - failed to parse localstore user data')
      return dispatch('setCurrentUser', null)
    }

    if (!(userData && userData.token)) {
      //- No parsable userdata in localstore
      return dispatch('setCurrentUser', null)
    }

    //- Set Auth headers for requests
    API.setHeaders('Authorization', `Bearer ${userData.token}`)

    // Get user to see if we have correct credentials
    API.getUser(userData.id)
      .then(res => {
        //- User stored in localstore was ok and we can proceed as logged in
        //- Save (ie. update values for) user in localStorge
        //- Token is only received when logging in, so keep that from stored user
        return dispatch(
          'setCurrentUser',
          merge(res.data, {token: userData.token})
        )
      })
      .catch(error => {
        //- User stored in localstore was not ok
        console.log('Store - failed to get user: ' + error)
        return dispatch('setCurrentUser', null)
      })
  },

  //- Sets fetched notifications
  setNotifications({commit, dispatch}, notifications) {
    //- Mutate store
    commit('SET_NOTIFICATIONS', notifications)
  }
}

export default actions
